import { RpcRequestError } from '../../errors/request.js';
import { http } from './http.js';
let id = 0;
export const rpc = async (url, { body, fetchOptions = {}, timeout = 10000 }) => {
    const body_ = {
        jsonrpc: '2.0',
        id: id++,
        ...body,
    };
    const data = await http(url, {
        body: body_,
        fetchOptions: {
            ...fetchOptions,
            method: fetchOptions.method || 'POST',
        },
        timeout,
    });
    if (data.error) {
        throw new RpcRequestError({
            url,
            body,
            error: data.error,
        });
    }
    return data;
};
//# sourceMappingURL=rpc.js.map